/* ========================================== */
/* テスト作成関連
/* ========================================== */
window.addEventListener( "DOMContentLoaded", function(){
  /* ------------------------------------------ */
  /* テスト作成ボタンクリック時の処理 */

  btn_test_create.addEventListener("click", function(){

    // 問題が選択されていなければ、テスト作成ボタンクリックでエラー表示。
    // モックアップ実装段階では、選択済み問題が非表示の場合で分岐させているが、
    // システム実装時は、右カラムの選択済み問題が最低１つは登録されている状態となる。
    if(list_selected_question.style.display != 'block') {
      showErrModal(err_msg_create01);
      return false;
    }

    let chk_kanten = document.getElementById('chk_page04'); //観点集計欄チェック
    let chk_haiten = document.getElementById('chk_page06'); //配点チェック
    let col_points = document.getElementById('modal_col_points'); //テスト作成モーダル内の配点からむ

    //観点集計欄、配点のチェック状況から、モーダル内の配点カラム（右カラム）の表示内容を振り分ける
    //class: case1（両方チェック）、case2（配点のみチェック）、case3（観点集計欄のみチェック）、case4（チェック無し）
    col_points.classList.remove('case1','case2','case3','case4');
    if(chk_kanten.checked && chk_haiten.checked ) {
      col_points.classList.add('case1'); //case1
    }else if(!chk_kanten.checked && chk_haiten.checked ) {
      col_points.classList.add('case2'); //case2
    }else if(chk_kanten.checked && !chk_haiten.checked ) {
      col_points.classList.add('case3'); //case3
    }else{
      col_points.classList.add('case4'); //case4
    }


    //テスト作成モーダル（プレビュー）表示
    test_modal.style.visibility = "visible";
    test_modal.style.opacity = 1;

  });

  /* ------------------------------------------ */
  /* モーダル内のテスト設問番号クリック時の処理 */
  //すべての設問番号にイベントリスナを定義する
  for (var i = 0; i < btn_jump_position.length; i++) {
    jumpQAPosition(btn_jump_position[i], i);
  }


  //保存ボタンクリック時
  btn_save.addEventListener("click", function(){
    // alert("保存処理実行");
    // デモ用データをダウンロードします。
    let element = document.createElement('a');
    element.href = "./data/science/download/files.zip";
    element.download = "3学期期末テスト.zip";
    element.target = "_blank";
    element.click();
  });
});

//モーダル内のテスト設問番号クリック時の自動スクロール用イベントリスナ
//jQueryだと2行くらいで出来るのになんでこんなに面倒くさいんだ～
function jumpQAPosition(questionDOM, questionId){
  questionDOM.addEventListener("click", function() {

    //一旦すべてのボタンの選択状態を解除
    for (var i = 0; i < btn_jump_position.length; i++) {
      btn_jump_position[i].classList.remove('active');
    }
    this.classList.add('active');

    //設問
    var tgt_q = 'q'+this.dataset.tgt;
    var tgt_element_box1 = document.getElementById('preview1_in');
    var tgt_element_q = document.getElementById(tgt_q);
    var tgt_position_q = tgt_element_q.offsetTop - 40;

    //解答
    var tgt_a = 'a'+this.dataset.tgt;
    var tgt_element_box2 = document.getElementById('preview2_in');
    var tgt_element_a = document.getElementById(tgt_a);
    var tgt_position_a = tgt_element_a.offsetTop - 50;

    //スクロール実行
    tgt_element_box1.scrollTo({ top: tgt_position_q, behavior: 'smooth' });
    tgt_element_box2.scrollTo({ top: tgt_position_a, behavior: 'smooth' });

  });
}